import React, { Fragment ,useContext, useEffect, useState, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Style from 'style-it';
import "bootstrap/dist/css/bootstrap.css";
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Button from "@material-ui/core/Button";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import "./App.css";
import {columnsFilter} from './dataconfig/columnsGrids'

import {
  SHOW_TOOL_BAR,
  SHOW_LEFT_SIDE_BAR,
  SHOW_FOOTHER,  
  apiDataUrl,apiListUrl,apiSaveUrl, thisMock
} from './projConst';
import {main_data,main_data_empty,main_data_row_empty} from './api/mockData';
import {pick_data} from './api/mockDepend';
import {main_save_data} from './api/mockSaveData';

import ShowAppHeader from "./Components/ShowAppHeader";
import ShowAppFooter from "./Components/ShowAppFooter";
import ShowAppToolbar from "./Components/ShowAppToolbar";
import ShowAppSidebar from "./Components/ShowAppSidebar";
import ShowGrid from "./Components/Lib/ShowGrid";
import TestGrid from "./Components/Lib/TestGrid";
import ShowTotal from "./Components/ShowTotal";
import ShowFilter from './Components/Lib/ShowFilter';
import FormGrid from "./Components/FormGrid";

import { DataServerContext } from "./Server/DataServerContext";
import { InfoWinContext } from "./infowindow/infowinContext";

import * as api from "./api/apiFunc";
import * as R from 'ramda'
import { shallowEqual, useDispatch,useSelector } from 'react-redux'
import {columnsMainData,columnsTotalData
} from './dataconfig/columnsGrids'


const useStyles = makeStyles(theme => ({
  responsPerson: {
    margin: theme.spacing(),
    height: 900,
    width: "auto"
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  apptitle: {
    display: 'flex',
    width: '100%'
  },
  apptab: {
    minWidth: '80% !important',
  },
  appinnertab: {
    marginTop: '-30px'
  },
  usertitle: {
    alignSelf: 'center'
  },
/*
  root: {
    margin: theme.spacing(),
    textAlign: "left"
  },*/
  content: {
    paddingLeft: -theme.spacing(5),
    textAlign: "center"
  },
  title: {
    paddingLeft: theme.spacing(3),
    textAlign: "left",
    color: "#000",
    backgroundColor: "#d9d9d9",
    fontSize: "75%",
    fontWeight: "bold",
    height: 5
  },
}));

const defaultTabKey = '1';

function App (props) {
  const classes = useStyles();
  const {curmessage,messageWin,alertWin,alertmessage,dialogWin,
    dialog,dialoganswer } = useContext(InfoWinContext);
  const { loading, getServerDataRedux, dataserver } = useContext(DataServerContext);

  const { tree,db,argum,iconsApp,configApp,themeCss,globalCss} = props
  const dispatch = useDispatch();

  const [mainlist, SetMainList] = useState([]);
  const [mainfilter, SetMainFilter] = useState([]);
  const [totallist, SetTotalList] = useState([]);
  const [totaltable, SetTotalTable] = useState([]);
  const [pick, SetPick] = useState([]);

  const [scrollY, setScrollY] = useState(0);
  const [updatedData, SetUpdatedData] = useState([]);
  const [deleteData, SetDeleteData] = useState([]);
  const [insertData, SetInsertData] = useState([]);
  const [showFilter, SetShowFilter] = useState({ open: false, title: 'Фильтр по полям', mess: "" });
  const [curentRow, SetCurentRow] = useState({});
  const [subfilter, Setsubfilter] = useState(false);
    
  function logit() {
    setScrollY(window.pageYOffset);
    console.log('axssaxasxsax')

  }  
  const maindata = useSelector(state=>state.maindata,shallowEqual)
  const listdata = useSelector(state=>state.listdata,shallowEqual)

  useEffect(async () => {
      dispatch(getServerDataRedux(apiDataUrl, true, prepareParam({ datafilter: mainfilter }), thisMock, main_data, 'FETCH_MAIN_DATA',main_data_empty))
      //dispatch(getServerDataRedux(apiListUrl, true, prepareParam(), thisMock, pick_data, 'FETCH_LIST_DATA'))
  }, []);

/*  useEffect(() => {
    function watchScroll() {
      window.addEventListener("scroll", logit);
    }
    watchScroll();
    // Remove listener (like componentWillUnmount)
    return () => {
      window.removeEventListener("scroll", logit);
    };
  }, []);  
*/
   useEffect(() => {
    if (api.isEmpty(maindata)) return
       SetMainList(maindata.serverdata.datamain);
       SetMainFilter(maindata.serverdata.datafilter);
       SetTotalList(api.SumTotalRow(maindata.serverdata.datamain));
       //SetTotalTable(maindata.serverdata.datatotal);
       SetTotalTable(api.SumTotalVid(maindata.serverdata.datamain));
      }, [maindata]);

   useEffect(() => {
    if (api.isEmpty(listdata)) return
        SetPick(listdata.serverdata.picklists);
      }, [listdata]);
  
  useEffect(() => {
    if (dialoganswer.winDialogAnswer && dialoganswer.userDialogAnswer.answer) {
      switch (dialoganswer.userDialogAnswer.id) {
        case 1:
          handle_delete_row()
          break;
        }
    }
  }, [dialoganswer])

  const prepareParam = (userarg=null) => {
    const { tree, db } = props
    const appParams = { tree, db };

    return userarg ? {appParams,...userarg} : {appParams}
  } 

  const handleColumnFilter =() => {
    //console.log('this.ToggleColumnFilter',this.ToggleColumnFilter); 
   /* if (toggleColumnfilter) {
       ToggleColumnFilter = R.not(this.ToggleColumnFilter)
       SetToggleColumnfilter({toggleColumnfilter: this.ToggleColumnFilter});
        
       //this.props.onChangeFilterLoc('')
    } */
 
     SetShowFilter({open : true,
       title:'Фильтр по полям',
       mess : ""
     })
   
  }
  
  const handleSeek = (val,args) => {
    console.log('handleSeek',val,args)
    // R.keys(row).map(key => row[key].toString().indexOf(args) !== -1 ) 
    if (args.arg1 == "") {
      SetMainList(maindata.serverdata.datamain)
      return 
    }
    SetMainList(maindata.serverdata.datamain.filter(row => 
      row.ID.toString().indexOf(args.arg1) !== -1 ||
      row.DIRECTIONCODE.toString().indexOf(args.arg1) !== -1 ||
      row.DIRECTIONNAME.indexOf(args.arg1) !== -1 ||
      row.DIRECTIONNAMEEN.indexOf(args.arg1) !== -1 
     ))
  }
  const onHandleSave = (name,data) => {
    //props.SaveDict({ table: name, data })
  }
  
  const handleCurRow = (row) => { 
    SetCurentRow(row)
  }

  const onHandleAdd = (name, row) => { 
      SetMainList([...mainlist,row])
  }

  const onHandleDelete = (name, row, pkid) => { 
      SetMainList(mainlist.filter(el => el[pkid] !== row[pkid]))
  }

const onHandleUpdateGrid = (rows,currow,updated) => {
  SetMainList(rows);
  if (!api.isEmpty(updated)) {
   if (typeof updated.ID === 'number') {
      let idx = R.findIndex(R.propEq('ID', updated.ID))(updatedData)
      if (idx !== -1) {
        let updData = [...updatedData]
        //const newupdated = updated.updated
        //updData[idx] = { ...updData[idx], ...newupdated }
        updData[idx] = { ...updData[idx], ...currow }
        //const ID = updData[idx].ID
        //updData[idx] = { ...updData[idx], ..._updated }
        SetUpdatedData(updData)
      }
      else {
        //const temp = { ID: updated.ID, ...updated.updated }
        const temp = { ID: updated.ID, ...currow }
        SetUpdatedData([...updatedData, temp])
      }
  }
  else {
      let idx = R.findIndex(R.propEq('ID', updated.ID))(insertData)
     if (idx !== -1) {
       let updData = [...insertData]
       const newupdated = updated.updated
       updData[idx] = { ...updData[idx], ...newupdated }
       SetInsertData(updData)
      }
      else {
          const temp = { ID: updated.ID, ...updated.updated }
          SetInsertData([...insertData, temp])
        }
   }
   }
  } 
  const handleScroll = (event) => {
    let scrollTop = event.srcElement.body.scrollTop
    console.log('scrollTop ==',scrollTop);
    let itemTranslate = Math.min(0, scrollTop / 3 - 60)
    
   }
  const handleFilterAnswer = (answer, listFilter) => {
    SetShowFilter({open : false,title:'Фильтр по полям', mess : ""})
    if (answer == false) return
    SetMainFilter(listFilter)

    let check = false
    R.keys(listFilter).map(key => check = listFilter[key] !== null ? true : check)
    if (!check) {
      SetMainList(maindata.serverdata.datamain)
      Setsubfilter(false)
      messageWin("Фильтр очищен.");
    }
    else {
      let templist = [...mainlist]
      R.keys(listFilter).map(key => {
        if (listFilter[key] !== null)
          templist = templist.filter(row => {
            let res
            if (typeof row[key] === 'number')
              res = row[key] == Number(listFilter[key])
            if (typeof row[key] === 'string')
              res = row[key].toString().indexOf(listFilter[key]) !== -1
            
            return (res)
          })
      })
      SetMainList(templist)
      Setsubfilter(true)
      messageWin("Данные отфильтрованы ...");
    }
  }
  const handleSaveData = () => {
    let tempins = [...insertData].reduce((arr, el) => {
      let tmp = { ...el }
      tmp.ID = 0
      return [...arr, { ...tmp }]
    }, [])
    
    console.log("updatedData", JSON.stringify({updatedData: updatedData,deleteData,insertData : [...tempins] }))
    dispatch(getServerDataRedux(apiSaveUrl, true, prepareParam({updatedData,deleteData,insertData : [...tempins]}), thisMock, main_data, 'FETCH_MAIN_DATA'))
    SetUpdatedData([])
    SetDeleteData([])
    SetInsertData([])
    messageWin("Данные сохранены .");
  }
  const handle_delete_row = async () => {
    //dispatch(getServerDataRedux(apiSaveUrl, true, prepareParam({action: 'delete', card_id:cardid }), thisMock, main_data, 'FETCH_MAIN_DATA',{},"Карта удалена!")) 
    SetMainList(mainlist.filter(el => el.ID !== curentRow.ID))
    SetDeleteData([...deleteData, { ID: curentRow.ID }])
  }
  const handleDeleteRow = () => {
    return dialogWin(1, 'Сообщение', `Удалить запись ?`, false, 'handle_delete_row()') 
  }
  const handleInsertRow = () => {
    let newrow = main_data_row_empty
    let random_id = "ins-";
    let random_possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < 20; i++) {
      random_id += random_possible.charAt(Math.floor(Math.random() * random_possible.length));
    }
    newrow.ID = random_id 
    const newrows = [...mainlist]
    newrows.push({...newrow}); 
    SetMainList(newrows)
  }
  const onHandleMessage = (mess) => {
    messageWin(mess)
  }
  
 return (
    <Fragment>
      <Style>
         {themeCss}
      </Style>
      <Style>
         {globalCss}
      </Style>
     <div className='App'>
      {!api.isNotEmptyArr(configApp) && <api.Spinner />}
      {api.isNotEmptyArr(configApp) && <Fragment>
        <div style={{position: 'absolute',top:0,left:0,width:'100%'}}>
          <ShowAppHeader
            config={{ iconsApp, configApp, name: 'header' }}
            viewmode={null}
            messageSimple={() => ("Простое сообщение")}
            messagetitle={" Шаблон клиенского приложения (единый интерфейс) ."}
            alertSimple={() => alertWin("info", "Расширенная инфа о сайте")}
            errorSimple={() => alertWin("error", "Вывод ошибки")}
            nameNsi={"Справочник направлений"}
          />
          {SHOW_TOOL_BAR && <ShowAppToolbar
             config={{ iconsApp, configApp, name: 'toolsbar' }}
             filtered={subfilter}
            handleSeek={handleSeek}
            onColumnFilter={handleColumnFilter}
            onSaveData={handleSaveData}
            onDeleteRow={handleDeleteRow} 
            onInsertRow={handleInsertRow}
            pick={pick}
            mainfilter={mainfilter}
            //onColumnFilterLoc = {this.handleColumnFilterLoc.bind(this)}
          />}
        </div>  
        {SHOW_LEFT_SIDE_BAR && <div style={{position: 'absolute', top: '15vh', left: '1vh', width: '100%' }}>
          <ShowAppSidebar
            config={{ iconsApp, configApp, name: 'left-sidebar' }}
          />
        </div>}
        <div style={{position: 'absolute', top: '16vh', left: '0', width: '100%' }} className={"main-content"}>
          <div id='datagrid' className="forPaper">
              <ShowGrid
               name='Main_data'
               PrimaryId='ID'
               columnsgrid={columnsMainData}
               data={mainlist}
               maxwidth={2}
               readonly={false}
               minHeight={620}
                
               onHandleMess={onHandleMessage}
               onSaveData={onHandleSave}
               onHandleUpdateGrid={onHandleUpdateGrid}
               onHandleDelete={onHandleDelete}
               onHandleAdd={onHandleAdd}
               onCurRow={handleCurRow}
               onMessage={(mess)=>dialogWin(1, 'Внимание', mess , true)}
          />
            {/* <TestGrid/>*/}
            
              <ShowFilter
                open={showFilter.open}
                title={showFilter.title}
                columns={columnsFilter}
                pick={pick}
                deffilter={mainfilter}
                onAnswer={handleFilterAnswer}
              />
          </div> 
        </div> 
        {SHOW_FOOTHER && <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%' }}>
          <ShowAppFooter
            config={{iconsApp,configApp,name:'footer'}}
          />
        </div>}  
       </Fragment>}
      </div>
    </Fragment>
  );
}

export default App;
